export default function fPhoneUnformat(phone: string) {
    return phone
        .replaceAll(' ', '')
        .replaceAll('-', '')
        .replaceAll('_', '')
        .replaceAll('+7', '')
        .replaceAll('(', '')
        .replaceAll(')', '');
}
